<section *ngIf="!isOpened" class="container-fluid">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formDevolutionProjection">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- ELIMINAR -->
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteDevolutionProjection()"></app-custom-button>
              <!-- NUEVO -->
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                (onClick)="createNewRegister()" [severity]="'success'" [width]="'5rem'"
                [variant]="undefined"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="devolutionProjectionContract.userNameCreate"
                [createDate]="devolutionProjectionContract.createDate"
                [userNameUpdate]="devolutionProjectionContract.userNameUpdate"
                [updateDate]="devolutionProjectionContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event, false)">
                  </app-custom-select>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                  <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                    [list]="filteredCostCenters" [required]="true" [recovery]="true"
                    [class]="costCenterInvalid ? 'state-inactive' : ''" (onChangeSelect)="changeCostCenter($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-8 col-sm-8 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                    [required]="true" [class]="clientInvalid ? 'state-inactive' : ''"
                    (onChangeSelect)="changeClient($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4 col-12">
                  <app-custom-datepicker formControlName="dateDevolutionProjection" [labelText]="'Fec.Devolución'"
                    [required]="true">
                  </app-custom-datepicker>
                </div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 ms-auto d-flex justify-content-end align-items-end mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                    (onClick)="send()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-devolution-projection-detail [devolutionProjectionModel]="devolutionProjectionContract"
      (emitQuantityDetails)="quantityDetails = $event">
    </app-devolution-projection-detail>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>